var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$loader.displayed)?_c('div',{staticClass:"loader-overlay",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centered"},[_c('div',{staticClass:"spinner"},[_c('div'),_c('div')])])
}]

export { render, staticRenderFns }